import React from 'react';
import Label from '~/src/atoms/Label/';
import tw from 'twin.macro';
import { DeckContext } from './DeckContext';
import PackChanger from './PackChanger';
import CosmeticSelector from './CosmeticSelector';

const PackSelector = ({ showPackSize = true, screenType, analyticsAttrs = {}, citrusAdId = {}, screenTypeId, onClick = () => {}, ...rest }) => {
  const { packSelected = { weight: '', packDesc: '' }, packSizes = [] } = React.useContext(DeckContext);
  const isParentChild = packSelected?.additionalAttributes?.info?.find((value) => value?.type === 'parent_child_variant_type');

  if (!showPackSize || !packSelected?.id) {
    return (
      <div className="w-full py-3 border border-transparent">
        <div className="py-0.5" />
      </div>
    );
  }

  if (isParentChild) {
    return <CosmeticSelector onClick={onClick} />;
  }

  if (packSizes?.length > 1) {
    return (
      <PackChanger
        screenType={screenType}
        citrusAdId={citrusAdId}
        analyticsAttrs={analyticsAttrs}
        onClick={onClick}
        screenTypeId={screenTypeId}
        fromExtendedList={rest.fromExtendedList}
      />
    );
  }

  return (
    <Label
      css={tw`block px-2 h-7 xl:h-7.5 flex items-center lg:text-sm xl:text-md truncate border border-solid bg-silverSurfer-100 border-silverSurfer-200 rounded-2xs text-darkOnyx-400`}
      {...rest}>
      <Label className="truncate">{`${packSelected?.weight} ${packSelected?.packDesc ? `- ${packSelected?.packDesc}` : ''}`}</Label>
    </Label>
  );
};

export default PackSelector;
